import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo_java.svg'


const _hoisted_1 = {
  class: "modal modal-lg fade",
  id: "modal-download-instruction",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body pt-1" }
const _hoisted_5 = { class: "java-information d-flex" }
const _hoisted_6 = { class: "description px-3 pt-1" }
const _hoisted_7 = { class: "text text-start fs-6" }
const _hoisted_8 = {
  class: "link",
  href: "https://www.java.com/pt-BR/",
  target: "_blank"
}
const _hoisted_9 = { class: "text text-start mt-3" }
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h1", {
            class: "modal-title fs-5",
            id: "messageModalAreYouShure"
          }, "Download do emissor"),
          _createElementVNode("button", {
            class: "btn-close",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Fechar"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "img-container" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Logo Java"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text text-start fs-6 mb-2" }, "Antes de fazer o download do emissor, você precisa ter o Java instalado e atualizado em seu computador.", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", _hoisted_8, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "Clique aqui para fazer o download", -1)),
                  _createVNode(_component_Icon, {
                    class: "mx-2 icon",
                    name: "download"
                  })
                ])
              ])
            ])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text text-start fs-6 mt-3" }, [
            _createElementVNode("strong", null, "Após o download, siga os passos até a conclusão da instalação.")
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Icon, {
              class: "icon pe-1",
              name: "circle-check",
              style: {"color":"var(--color-success)"}
            }),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fs-6" }, [
              _createTextVNode("Tenha em mãos seu "),
              _createElementVNode("strong", null, "usuário*"),
              _createTextVNode(" e a senha de emissão do seu Certificado Digital.")
            ], -1))
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text text-start fs-6 mt-4 mx-4" }, "* Você pode encontrar seu código de usuário em seu e-mail com o texto: “Emissão de Certificado Digital APROVADA” no assunto.", -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("a", {
            id: "dowload-link",
            href: _ctx.issuerUrl
          }, null, 8, _hoisted_11), [
            [_vShow, false]
          ]),
          _createElementVNode("button", {
            class: "btn modal-footer_btn-process btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
            "data-bs-dismiss": "modal"
          }, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "download"
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Baixar emissor", -1))
          ])
        ])
      ])
    ])
  ]))
}